import { withStyles, DialogContent } from '@material-ui/core';

export const StyledDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent);

export type StyledDialogContentType = typeof StyledDialogContent;
